import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioRenFrWindExt } from '@/classes/scenario/ren-fr/wind/ScenarioRenFrWindExt';

const getDefaultFields = () => new ScenarioRenFrWindExt();

export const buildRenFrWindModule = () => {

  @Module({
    namespaced: true
  })
  class RenFrWindModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioRenFrWindExt {
      return this.getConfig.ren_fr_wind ? new ScenarioRenFrWindExt(this.getConfig.ren_fr_wind) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return RenFrWindModule;
};
